<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-06-07 17:08:39
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-05-22 12:11:04
 * @FilePath: \jyrg-web\src\components\public\VoucherCenter\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="main">
    <div id="mask"  v-show="recordShow"></div>
    <transition name="el-zoom-in-top">
      <div class="map-order" v-show="recordShow">
        <img
          class="close"
          src="../../../assets/image/pc/close.png"
          alt=""
          @click="close"
        />
        <div class="title">中奖记录</div>
        <div class="record">
          <div class="item" v-for="i in recordList" :key="i.id">
            <a>{{ i.item_name }}</a>
            <a>{{ i.gift_code }}</a>
            <a @click="copy(i.gift_code)">复制</a>
          </div>
          <div  class="item" v-show="codeShow==1">
                    <a v-show="codeShow==1">宣传码</a>
                    <a  v-show="codeShow==1">{{propagateCode }}</a>
                    <a @click="copy(propagateCode)"  v-show="codeShow==1">复制</a>
          </div>
          <div  class="item" v-show="anchorShow==1">
                    <a v-show="anchorShow==1">主播码</a>
                    <a  v-show="anchorShow==1">{{anchorCode }}</a>
                    <a @click="copy(anchorCode)"  v-show="anchorShow==1">复制</a>
          </div>
        </div>
        <div class="warn">
  
          <p>游戏内右上角点击更多-设置-账号-兑换码兑换</p>
          <p>
            注：每个账号最多使用四次抽奖获得的兑换码！
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Notification } from "element-ui";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { getToken } from "@/utils/auth";
import orderApi from "@/api/orderApi";
import webSite from "../../../api/webSite";
export default {
  props: {
    show: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  data() {
    return {
      recordShow:false,
      recordCloseShow:false,
      recordList:[],
      codeShow:0,
      anchorShow:0,
      propagateCode:"",//宣传码
      anchorCode:"",//主播码
    };
  },
  computed: {
    // recordList() {
    //   return this.$store.state.user.luckRecordList;
    // },
    //    propagateCode() {
    //   return this.$store.state.user.propagateCode;
    // },
    propagateButtonType() {
      return this.$store.state.user.propagateButtonType;
    },
  },
  mounted() {
     this.getLuckRecordList();
     this.getAnchorCode();
  },
  methods: {
    ...mapActions({ Login: "user/Login" }),
    // 关闭
    close() {
      this.recordShow=false;
      // this.$emit("close", false);
    },
    // 高层级message
    messageTip(message, type) {
      this.$message({ message, type, customClass: "messageIndex" });
    },
    async  getLuckRecordList() {
      if(getToken()!=undefined){

        let params = {token:getToken()};
      const res = await orderApi.luckRecordList(params);
      this.recordList=res.data;
      let paramCode = {phoneNumber: this.$store.state.user.userPropagateInfo};
      let resCode = await webSite.getUploadImages(paramCode); 
      if(resCode.code==200){
        this.propagateCode= resCode.data[0].giftCode //获取宣传码
        if(this.propagateCode!=null){
        this.codeShow=1;
      }
  
      }
   
    }
    
    },
    //获取主播码
    async  getAnchorCode() {
      let params = { token: getToken()};
      const res = await orderApi.getUserInfoCode(params);
      if(getToken()!=undefined){
          if (res.result == 1) { 
            this.anchorCode=res.data.gift_code; 
            this.anchorShow=1;
  
          }  
          }
    
    },
    // 一键复制
    async copy(content) {
      try {
        let res = await this.$utils.doCopy(content);
        Notification({
          title: res,
          offset: 50,
          customClass: "messageIndex",
          type: "success",
        });

        setTimeout(() => {
          this.dialogShow = false;
        }, 1000);
      } catch (error) {
        Notification({
          message: error,
          offset: 50,
          customClass: "messageIndex",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  #mask {
    position: fixed;
    top: 0;
    // width: 100%;
    min-width: 1920px;
    height: 100vh;
    display: flex;
    justify-content: center;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 9998;
  }
  .main {
    position: fixed;
    display: flex;
    justify-content: center;
    
    z-index: 9998;
    .map-order {

      // flex-direction: column;
      height: 150px;
      z-index: 9998;
     margin-left:140px;
     margin-top:20px;
      border-radius: 5px;
      background-image: linear-gradient(to top, #e6b980 0%, #eacda3 100%);

      .title {
        width: 100px;
        line-height: 30px;
       text-align: center;
        font-size: 12px;
        font-family: "字体一";
      }
      .record {
        width: 100px;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        .item {
          width:100%;
          height: 25px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size:6px;
          border-bottom: 1px solid #000;
          a {
            text-align: center;
            flex: 1;
            cursor: pointer;
          }
        }
      }
      .warn {
        position: absolute;
        bottom: 2%;
        p{
          margin-left: 10px;
        }
      }
      .close {
        position: relative;
        top: -3%;
        right: 3%;
        transform-origin: 50% 50%;
        transition: transform 0.5s ease; /* 添加过渡效果，使翻转更平滑 */
      }
      .close:hover {
        transform: rotate(180deg); /* 鼠标悬停时顺时针翻转180度 */
      }

      @keyframes close {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(90deg);
        }
      }
    }
  }

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
}
</style>
